<template>
	<!-- 榜单 -->
	<div class="ranklist ">

		<div class="bullehead FlexBetween">
			<div class="head_left ">
				<div class="head_title">
					{{title || ''}}
				</div>
			</div>
			<div class="head_right FlexRow">
				<div class="more_span" @click="clickmore">
					更多
				</div>
			</div>
		</div>


		<div class="rank_body">
			<el-table :data="tableData" :header-cell-style="cellstyle" :row-style="rowstyle"
				style="width: 99%;margin: 0 auto;">
				<el-table-column align="center" width="60" label="排名">
					<template v-slot="scope">
						<div class="rank_icon FlexRow">
							<div class="rank_num" :class="scope.row.className">
								{{scope.$index + 1}}
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column v-if="types < 4" show-overflow-tooltip  prop="name" label="内容">
				</el-table-column>
				<el-table-column v-if="types > 3" show-overflow-tooltip prop="name" label="成员名字">
				</el-table-column>
				<el-table-column prop="count" show-overflow-tooltip width="80" :label="collabel">
				</el-table-column>

			</el-table>
		</div>

	</div>
</template>

<script>
	import {
		fn_overload,
	} from "../js/billet.js"
	export default {
		name: 'ranklist',
		props: {
			types: {
				type: Number,
				default: 1,
			},
			dataobj: {
				type: Object,
				default: ()=>{
					return {}
				},
			},
		},
		data() {
			return {
				cellstyle: {
					background: 'rgba(241, 245, 255, 1)',
					border: 'none',
				},
				rowstyle: {
					height: '46px',
				},
				tableData: [],
				title: '文章引流榜单',
				collabel: '引流数量',
			}
		},
		watch: {
			dataobj(){
				this.fn_SetDatas()
			},
		},
		methods: {
			clickmore(){
				let path = this.types < 4 ? '/data/bulletinboard/sharepag' : '/data/bulletinboard/membrpag';
				let typeArr = [2, 3, 4, 1, 2, 3]
				let sort_type = typeArr[this.types - 1]
				this.$router.push({
					path, 
					query:{
						sort_type,
				    }
				})
			},
			fn_SetDatas(){
				if(!this.dataobj) return 
				let listKeyArr = [
					'drainage_list',
					'cuepool_list',
					'customer_list',
					'member_drainage_list',
					'member_cuepool_list',
					'member_customer_list',
				]
				let ckey = listKeyArr[this.types - 1]
				let list = this.dataobj[ckey] || []
				this.getdatalist(list)
			},
			getdatalist(list) {
				let n = 0
				for(let item of list) {
					item.className = ''
					item.count = fn_overload(item.count)
					if (n < 4) {
						item.className = `cRank${n+1}`
					}
					if(this.types == 4) {
						item.count = fn_overload(item.drainage_num)
					}
					else if(this.types == 5) {
						item.count = fn_overload(item.cuepool_num)
					}
					else if(this.types == 6) {
						item.count = fn_overload(item.customer_num)
					}
					n += 1;
				}
				this.tableData = list
			},
			fn_inti() {
				let arr = [
					'引流数量', '线索数量', '获客数量',
					'引流数量', '线索数量', '获客数量',
				]
				let titarr = [
					'文章引流榜单', '文章线索榜单', '文章获客榜单',
					'成员引流榜单', '成员线索榜单', '成员获客榜单',
				]
				if (this.types && typeof(this.types) == 'number') {
					this.collabel = arr[this.types - 1]
					this.title = titarr[this.types - 1]
				}
			},
		},
		created() {
			this.fn_inti()
		},
	}
</script>

<style lang="scss" scoped>
	@import "../css/billet.scss";

	.more_span {
		cursor: pointer;
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 0px;
		color: rgba(43, 117, 235, 1);
	}

	.ranklist {
		width: 100%;
		// min-width: 397px;
	}

	.rank_body {
		width: 100%;
		// min-height: 561px;
		padding: 22px 17px;
	}

	.rank_num {
		width: 25.08px;
		height: 24.47px;
		border-radius: 1px;
		background: rgba(245, 245, 245, 1);
	}

	.rank_num.cRank1 {
		color: #fff;
		background-color: rgba(248, 96, 86, 1);
	}

	.rank_num.cRank2 {
		color: #fff;
		background-color: rgba(252, 141, 46, 1);
	}

	.rank_num.cRank3 {
		color: #fff;
		background-color: rgba(252, 188, 46, 1);
	}
</style>
